<div *ngIf="this.loading" class="lds-ring-outer">
	<div class="lds-ring-inner"></div>
	<div class="lds-ring-inner"></div>
	<div class="lds-ring-inner"></div>
	<div class="lds-ring-inner"></div>
</div>
<ng-content>
</ng-content>